/* Omelva · «Te sale más barato en pack» (snippets/om-mejora-pack.liquid), en el cajón y en la página de carrito.
   Cambia las líneas de la braguita por la combinación de packs más barata conservando la talla y el color de cada
   prenda, en el mismo orden. Primero guarda una foto de las líneas; si Shopify rechaza los packs nuevos, las
   vuelve a poner tal cual. Al terminar avisa con el total nuevo que devuelve Shopify. */
(function () {
  if (window.omMejoraPack) return;

  function pedir(url, cuerpo) {
    return fetch(url, {
      method: cuerpo ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
      cache: 'no-store'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.description || 'HTTP ' + r.status); e.datos = d; throw e; }
        return d;
      });
    });
  }

  function dinero(centimos, moneda) {
    try { return (centimos / 100).toLocaleString('es-ES', { style: 'currency', currency: moneda || 'EUR' }); }
    catch (e) { return (centimos / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* Talla y color de cada prenda, leídos de las propiedades que Shopify tiene guardadas (y de lo que se esté
     eligiendo en pantalla, si aún no se ha guardado). */
  function prendasDe(lineas, raiz) {
    var prendas = [];
    lineas.forEach(function (l) {
      var enPantalla = raiz ? raiz.querySelector('[data-key="' + l.key + '"]') : null;
      var props = {};
      Object.keys(l.properties || {}).forEach(function (k) { props[k] = l.properties[k]; });
      if (enPantalla) enPantalla.querySelectorAll('select[data-omj-prop], select[data-omc-prop]').forEach(function (s) {
        var k = s.getAttribute('data-omj-prop') || s.getAttribute('data-omc-prop');
        if (s.value) props[k] = s.value;
      });
      var n = 0;
      Object.keys(props).forEach(function (k) { var m = /^Unidad (\d+) · /.exec(k); if (m) n = Math.max(n, +m[1]); });
      for (var u = 1; u <= n; u++) prendas.push({ t: props['Unidad ' + u + ' · Talla'] || '', c: props['Unidad ' + u + ' · Color'] || '' });
    });
    return prendas;
  }

  window.omMejoraPack = function (caja, alTerminar) {
    var boton = caja.querySelector('[data-om-mejora-btn]');
    var estado = caja.querySelector('[data-om-mejora-estado]');
    if (boton.disabled) return;
    boton.disabled = true;
    estado.textContent = 'Cambiando…';
    var quitar = (caja.getAttribute('data-quitar') || '').split(',').filter(Boolean);
    var plan = (caja.getAttribute('data-plan') || '').split(',').filter(Boolean).map(function (p) {
      var x = p.split(':'); return { id: +x[0], q: +x[1], n: +x[2] };
    });
    var raiz = caja.closest('[data-omj], [data-omc]') || document;
    var foto = null;

    pedir('/cart.js').then(function (c) {
      foto = (c.items || []).filter(function (l) { return quitar.indexOf(l.key) >= 0; });
      if (!foto.length) throw new Error('nada');
      var prendas = prendasDe(foto, raiz);
      var nuevos = [];
      plan.forEach(function (p) {
        for (var k = 0; k < p.q; k++) {
          var props = {};
          for (var u = 1; u <= p.n; u++) {
            var pr = prendas.shift() || { t: '', c: '' };
            if (pr.t) props['Unidad ' + u + ' · Talla'] = pr.t;
            if (pr.c) props['Unidad ' + u + ' · Color'] = pr.c;
          }
          nuevos.push({ id: p.id, quantity: 1, properties: props });
        }
      });
      var ceros = {};
      foto.forEach(function (l) { ceros[l.key] = 0; });
      return pedir('/cart/update.js', { updates: ceros }).then(function () {
        return pedir('/cart/add.js', { items: nuevos }).catch(function (err) {
          /* Vuelta atrás: se reponen las líneas de antes con sus propiedades y cantidades. */
          return pedir('/cart/add.js', { items: foto.map(function (l) { return { id: l.variant_id, quantity: l.quantity, properties: l.properties }; }) })
            .then(function () { throw err; });
        });
      });
    }).then(function () {
      return pedir('/cart.js');
    }).then(function (c) {
      var msj = 'Hecho. Total ahora: ' + dinero(c.total_price, c.currency) + '.';
      if (alTerminar) alTerminar(msj); else { estado.textContent = msj; }
    }).catch(function () {
      boton.disabled = false;
      estado.textContent = 'No se ha podido cambiar. Tu carrito sigue como estaba; vuelve a intentarlo.';
    });
  };
})();